import React, { useEffect, useState } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import Language from "Enums/Language"
import UnitSizesService from "services/Admin/UnitSizesService";

const languages = ["en", "ar", "zh", "ru"]

function ModalForm({
    modal,
    toggle,
    isAdd,
    editObj,
    type,
    setShouldGetData
}) {
    const [loading, setLoading] = useState(false)
    const service = new UnitSizesService()

    const [formData, setFormData] = useState({
        en: "",
        ar: "",
        ru: "",
        zh: "",
        options: []

    })
    useEffect(() => {
        if (editObj ?.id) {
            service.find(editObj ?.id).then(res => {
                if (res && res.status === SuccessOk) {
                    setFormData({
                        ...formData,
                        ...res.data.name
                    })
                }
            })
        }
    }, [])
    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleValidSubmit = () => {
        setLoading(true)
        if (isAdd) {
            let data = {
                name: {
                    en: formData.en,
                },
            }
            languages.forEach(language => {
                if (formData[language].length) {
                    data.name[language] = formData[language]
                }
            })
            service.create(data).then(res => {
                if (res && res.status === SuccessCreated) {
                    setShouldGetData(true)
                    toast.success("Unit Size Added successfully")
                    toggle()
                }else{
                    setLoading(false)
                    toast.error(res)
                }
            })
        } else {
            let data = {
                name: {
                    en: formData.en,
                    ar: formData.ar,
                    ru: formData.ru,
                    zh: formData.zh
                },
            }
            service.update(editObj.id, data).then(res => {
                if (res && res.status === SuccessOk) {
                    setShouldGetData(true)
                    toast.success("Unit Size Edited Successfully")
                    toggle()
                }else{
                    setLoading(false)
                    toast.error(res)
                }

            })
        }
    }

    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <ModalHeader toggle={toggle}>
                {isAdd ? `Add ${type} ` : `Update ${type}`}
            </ModalHeader>
            <ModalBody>
                <AvForm
                    className='form-horizontal'
                    onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v);
                    }}>
                    <Row>
                        {Language.LIST.map((lan, index) => {
                            return (
                                <Col md={6} key={index} className="mb-3">
                                    <AvField
                                        name={lan.name}
                                        label={lan.label}
                                        bsSize="lg"
                                        value={formData[`${lan.name}`]}
                                        onChange={(e => handleFieldChange(e))}
                                        // required={lan.name === "en" ? true : false}
                                        validate={{
                                            required: {value: lan.name === "en" ? true : false, errorMessage: 'This Field is required'},
                                            pattern: {value: lan.name === "en" ? '/^[A-Za-z ]+$/' : lan.name === "ar" ? '/^[\u0621-\u064A ]+$/' : "", errorMessage: `${lan.name=='en' ? "English" : "Arabic"} format is invalid`}
                                        }}
                                        placeholder={lan.name === "en" ? 'Name' : lan.name === "ar" ? "الاسم" : lan.name === "zh" ? "姓名" : "Каир"}
                                    />
                                </Col>
                            )
                        })}
                    </Row>

                    <ModalFooter className="px-0">
                        <button
                            disabled={loading ? true : false}
                            type='submit' className='btn btn-success w-100'>
                            {isAdd ? "Add" : "Update"}
                        </button>
                    </ModalFooter>
                </AvForm>
            </ModalBody>
        </Modal>
    );
}

export default ModalForm;
